module.exports = __webpack_public_path__ + "static/media/Phyllis.038dcc46.png";